import axios from 'axios';
import { Market } from 'views/feed-management/features/plants/types/market.type';

// GET
// Returns list of markets with basic info.
// /ewosapi/v1/bestmix/markets
export const getFeedManagementMarkets = async (): Promise<Market[]> => {
  const res = await axios.get<Market[]>(`/ewosapi/v1/bestmix/markets`);
  return res.data;
};
